import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Wordmark } from '@/components/brand';

/** Frame for pages shown outside the app shell: a banner with the wordmark and one main landmark. */
export function StandaloneLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <header className="h-12 shrink-0 border-b border-border">
        <div className="mx-auto flex h-full w-full max-w-7xl items-center px-4 sm:px-6 lg:px-8">
          <Link to="/" aria-label="ComfiConf home" className="focus-ring inline-flex rounded-sm">
            <Wordmark />
          </Link>
        </div>
      </header>
      <main id="main" tabIndex={-1} className="flex-1 outline-none">
        {children}
      </main>
    </div>
  );
}
